<template>
  <section class="wrapper-content bg-error fill-height">
    <v-row align="center" justify="center" class="fill-height">
      <v-col cols="10">
        <v-row align="center" justify="center">
          <v-col cols="12" md="6">
            <v-card class="rounded-lg" color="#f1f1f1">
              <v-toolbar color="#374850" flat>
                <v-toolbar-title>
                  <v-icon size="20" class="mx-2" color="#ea5553"
                    >mdi-checkbox-blank-circle</v-icon
                  >
                  <v-icon size="20" class="mx-2" color="#f8d314"
                    >mdi-checkbox-blank-circle</v-icon
                  >
                  <v-icon size="20" class="mx-2" color="#62c36a"
                    >mdi-checkbox-blank-circle</v-icon
                  >
                </v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-container>
                  <v-row align="center" justify="center">
                    <v-col cols="10">
                      <v-row align="center" justify="center">
                        <v-col class="text-center">
                          <v-icon color="#f8d314" size="100"
                            >fas fa-exclamation-circle</v-icon
                          >
                        </v-col>
                        <v-col>
                          <h1 class="font-weight-black text-center text-404">
                            415
                          </h1>
                        </v-col>
                      </v-row>
                      <v-row align="center" justify="center">
                        <v-col>
                          <p class="text-center text-paragraph">
                            Lo sentimos, pero no tienes acceso al recurso
                          </p>
                          <p class="text-center text-paragraph">
                            Haz click en
                            <span class="font-weight-bold">Regresar</span>
                          </p>
                        </v-col>
                      </v-row>
                    </v-col>
                  </v-row>
                </v-container>
              </v-card-text>
              <v-card-actions>
                <v-row align="center" justify="center" class="my-2">
                  <v-col cols="6" class="text-center">
                    <v-btn
                      rounded
                      color="#f8d314"
                      class="white--text"
                      @click="back()"
                    >
                      Regresar
                    </v-btn>
                  </v-col>
                </v-row>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
      </v-col>
    </v-row>
  </section>
</template>

<script type="JS">
import PRM from "../core/PermissionConstants";
import { UtilFront } from "@/core";

export default {
  name: "nofun",
  computed: {},
  data: () => ({}),
  methods: {
    back() {
      const token_decode = JSON.parse(localStorage.getItem("preferencias"));
      let newRoutes = [];
      if (token_decode.view_type === false) {
        let routes = this.$router.options.routes;
        for (let i = 0; i < routes.length; i++) {
          const route = routes[i];

          if (
            this.$utilFront.nonEmpty(route) &&
            this.$utilFront.nonEmpty(route.meta) &&
            this.$utilFront.nonEmpty(route.meta.requireAuth) &&
            this.$utilFront.nonEmpty(route.meta.prm)
          ) {
            if (
              (route.meta.requireAuth === true && !route.meta.prm == "") ||
              !route.meta.prm == "undefined"
            ) {
              if (
                this.$utilFront.withPermission(route.meta.prm) &&
                route.meta.pm == true
              ) {
                newRoutes.push(route);
              }
            }
          }
        }
        const newRoute = newRoutes.slice(0, 1).shift();
        this.$router.push(newRoute.path);
      } else if (token_decode.view_type === true) {
        this.$router.replace("/Recepcion");
      }

      // localStorage.clear();

      // if (this.$utilFront.withPermission(PRM.MODULE_RECEPTION)) {
      //   // this.$router.replace("/recepcion");
      //   this.$router.push(
      //     UtilFront.isViewAdmin()
      //       ? { name: "Recepcion" }
      //       : { name: "Dashboard" }
      //   );
      // } else if (this.$utilFront.withPermission(PRM.MODULE_DIARY)) {
      //   this.$router.push(
      //     UtilFront.isViewAdmin() ? { name: "Agenda" } : { name: "Dashboard" }
      //   );
      // } else if (this.$utilFront.withPermission(PRM.MODULE_CONSULTATION)) {
      //   this.$router.push(
      //     UtilFront.isViewAdmin()
      //       ? { name: "Consultas" }
      //       : { name: "Dashboard" }
      //   );
      // } else if (this.$utilFront.withPermission(PRM.MODULE_DENTAL)) {
      //   this.$router.push(
      //     UtilFront.isViewAdmin() ? { name: "ConsultaDental" } : { name: "Dashboard" }
      //   );
      // } else if (this.$utilFront.withPermission(PRM.MODULE_PHARMACY)) {
      //   this.$router.push(
      //     UtilFront.isViewAdmin() ? { name: "Farmacia" } : { name: "Dashboard" }
      //   );
      // } else if (this.$utilFront.withPermission(PRM.MODULE_LABORATORY)) {
      //   this.$router.push(
      //     UtilFront.isViewAdmin()
      //       ? { name: "IniciarEstudio2" }
      //       : { name: "Dashboard" }
      //   );
      // } else if (this.$utilFront.withPermission(PRM.MODULE_IMAGE)) {
      //   this.$router.push(
      //     UtilFront.isViewAdmin()
      //       ? { name: "IniciarEstudio1" }
      //       : { name: "Dashboard" }
      //   );
      // } else if (this.$utilFront.withPermission(PRM.MODULE_CLINIC_HISTORY)) {
      //   this.$router.push(
      //     UtilFront.isViewAdmin()
      //       ? { name: "HistoriaClinica" }
      //       : { name: "Dashboard" }
      //   );
      // } else if (this.$utilFront.withPermission(PRM.MODULE_USER)) {
      //   this.$router.push(
      //     UtilFront.isViewAdmin() ? { name: "Usuarios" } : { name: "Dashboard" }
      //   );
      // } else if (this.$utilFront.withPermission(PRM.MODULE_REPORTS)) {
      //   this.$router.push(
      //     UtilFront.isViewAdmin() ? { name: "Reportes" } : { name: "Dashboard" }
      //   );
      // } else if (this.$utilFront.withPermission(PRM.MODULE_CONF)) {
      //   this.$router.push(
      //     UtilFront.isViewAdmin()
      //       ? { name: "PACSConfiguration" }
      //       : { name: "Dashboard" }
      //   );
      // }
    },
  },
};
</script>

